import Request from "../lib/request";
import config from "../common/config";

const http = new Request();
let token = localStorage.getItem("newToken");

export function uploadUrl() {
  return (config.host1 || "") + "/api/upload/file";
}

export function uploadImg() {
  return (config.host1 || "") + "/api/upload/image";
}

export default {
  //分类
  getColumnList(params) {
    return http.get(config.host1, "/api/news-article/column", params);
  },
  //子分类
  getColumnChildrenList(params) {
    return http.get(config.host1, "/api/news-article/column_children", params);
  },
  //列表
  getArticleList(params) {
    return http.get(config.host1, "/api/news-article/get", params);
  },
  //详情
  getArticleDetail(params) {
    return http.get(config.host1, "/api/news-article/detail", params);
  },
  //新增留言
  addComment(params) {
    return http.post(config.host1, "/v6/garden/user/user-message-save", params);
  },
  //验证码
  getCaptcha(params) {
    return http.get(config.host1, "/v6/common/user/captcha", params);
  },
  //单位详情
  getCompanyDetail(params) {
    return http.get(config.host1, "/v6/home/changsuo/danwei_info", params);
  },
  //通知公告
  getNoticeList(params) {
    return http.post(config.host3, "/api/wechat/notice/list", params);
  },
  //通知公告详情
  getNoticeDetail(params) {
    return http.post(config.host3, "/api/wechat/notice/detail", params);
  },
  //轮博图列表
  getBannerList(params) {
    return http.post(config.host3, "/api/wechat/news/list", params);
  },
  //轮博图详情
  getBannerDetail(params) {
    return http.post(config.host3, "/api/wechat/news/detail", params);
  },
  //招聘会列表
  getRecruitmentList(params) {
    return http.post(config.host3, "/api/wechat/increase-jobfair/list", params);
  },
  //招聘会详情
  getRecruitmentDetail(params) {
    return http.post(config.host3, "/api/wechat/increase-jobfair/detail", params);
  },
  //招人才列表
  getRecruitmentPersonList(params) {
    return http.get(config.host3, "/api/talent/resume-list", params);
  },
  //找工作
  getFindJobList(params) {
    return http.get(config.host3, "/api/wechat/post/user/list", params);
  },
  //找工作详情
  // getFindJobDetail(params) {
  //   return http.get(config.host3, "/api/wechat/post/user/detail", params);
  // },
  //找工作详情1
  getFindJobDetail(params) {
    return http.get(config.host3, "/api/wechat/post/user/details", params);
  },
  //找工作详情2
  getFindJobDetail2(params) {
    return http.post(config.host3, "/api/wechat/increase-jobfair/company/detail", params);
  },
  // 找工作岗位列表
  getFindJobLists(params) {
    return http.post(config.host3, "/api/wechat/increase-jobfair/position/list", params);
  },
  //学技能
  getLearnSkillList(params) {
    return http.post(config.host3, "/api/wechat/increase-training/list", params);
  },
  //学技能详情
  getLearnSkillDetail(params) {
    return http.post(config.host3, "/api/wechat/increase-training/detail", params);
  },
  //政策指南
  getPolicyGuideList(params) {
    return http.post(config.host3, "/api/wechat/news/list", params);
  },
  //活动大厅
  getActivityList(params) {
    return http.get(config.host4, "/v6/following_love/index/index_activity_list", params);
  },
  //获取验证码图片
  getCaptchaSrc(params) {
    return http.get(config.host4, "/v6/common/user/captcha-src", params);
  },
  //验证码验证key
  // getCaptchaKey(params) {
  //   return http.get(config.host4, "/mobile/common/user/captcha", params);
  // },
  getCaptchaKey(params) {
    return http.get(config.host4, "/v6/common/user/captcha-src", params);
  },
  //发送短信验证码（手机验证码登录）
  sendSmsCode(params) {
    return http.post(config.host4, "/v6/common/send/verify/code", params);
  },
  //验证码检查（手机验证码登录）
  checkVerifyCode(params) {
    return http.post(config.host4, "/v6/common/check/verify/code", params);
  },
  //账号密码登陆
  login(params) {
    return http.post(config.host4, "/v6/common/user/inLogin", params);
  },
  //手机短信验证码登陆
  loginCode(params) {
    return http.post(config.host3, "/api/wechat/login", params);
  },
  //招聘会数量
  getRecruitmentCount(params) {
    return http.post(config.host3, "/api/wechat/increase-jobfair/count", params);
  },
};



// WEBPACK FOOTER //
// ./src/api/home.api.js